import OContextMenu from "@/components/OContextMenu"
import { Cell, Graph, Node, useGraphInstance } from "@antv/xflow"
import { useEffect, useState } from "react"
import { NodeContextMenu } from "./NodeContextMenu"
import { EdgeContextMenu } from "./EdgeContextMenu"
import { NodeShapes, SheetContent } from "../../services/modal"
import { isStream } from "../../events/helper"
import { useSelector } from "react-redux"
import { getSheetsSelector } from "@/store/flowsheet/flowsheet.slice"

interface ContextOption {
  cell: Cell
  e: PointerEvent
}

export const EditorContextMenu = () => {
  const graph = useGraphInstance()
  const [contextOption, setContextOption] = useState<ContextOption | null>(null)
  const sheets = useSelector(getSheetsSelector)

  useEffect(() => {
    if (!graph) return;
    const handle = (event) => {
      const { e, edge } = event
      setContextOption({e, cell: edge})
    }
    const nodeHandle = (event) => {
      const { e, node } = event
      setContextOption({e, cell: node})
    }
    graph.on('edge:contextmenu', handle)
    graph.on('node:contextmenu', nodeHandle)

    return () => {
      graph.off('edge:contextmenu', handle)
      graph.off('node:contextmenu', nodeHandle)
    }
  }, [graph])

  if (!contextOption || !graph) {
    return null
  }

  const { pageX, pageY } = contextOption.e
  const style = {
    left: pageX - window.scrollX,
    top: pageY - window.scrollY,
  }
  const cell = contextOption.cell
  const clickPoint = graph.clientToLocal(pageX, pageY)

  if (graph.isEdge(cell) && isStream(cell)) {
    return <OContextMenu onClose={() => setContextOption(null)}>
      <div style={style} className='context-menu'>
        <EdgeContextMenu
          clickPoint={clickPoint}
          edge={cell} sheets={sheets} graph={graph} onClose={() => setContextOption(null)} />
      </div>
    </OContextMenu>
  }

  if (graph.isNode(cell)) {
    return <OContextMenu onClose={() => setContextOption(null)}>
      <div style={style} className='context-menu'>
        <NodeContextMenu afterSelected={() => setContextOption(null)} node={contextOption.cell as Node}/>
      </div>
    </OContextMenu>
  }

  return null;
}